<app-complaints-list [isDasboard]="true"></app-complaints-list>
